import React from 'react';
import { BadgeCheck } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';

const TrustStrip = () => {
  const { t } = useLanguage();
  const items = t('trust.items');

  const stripStyle = {
    borderTop: '1px solid rgba(58, 58, 58, 0.6)',
    borderBottom: '1px solid rgba(58, 58, 58, 0.6)',
    backgroundColor: 'rgba(17, 17, 17, 0.9)',
    padding: '1.25rem 1.5rem'
  };

  const listStyle = {
    maxWidth: '72rem',
    margin: '0 auto',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: '0.75rem 2.5rem',
    listStyle: 'none',
    padding: 0
  };

  const itemStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#d1d5db',
    fontSize: '0.9rem',
    fontWeight: '500',
    whiteSpace: 'nowrap'
  };

  const iconStyle = {
    width: '1.1rem',
    height: '1.1rem',
    color: '#dfa926',
    flexShrink: 0
  };

  return (
    <section style={stripStyle} aria-label="Trust indicators">
      <ul style={listStyle}>
        {items.map((item, i) => (
          <li key={i} style={itemStyle}>
            <BadgeCheck style={iconStyle} />
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default TrustStrip;
